module.exports = __webpack_public_path__ + "img/img4_9.d5d41c6a.jpeg";